import { Behavior } from "../Behavior";
import { Particle } from "../Particle";
import type { IGrid } from "../types";

/**
 * 热传递行为
 * 允许粒子与周围的非空粒子交换热量
 */
export class HeatTransfer extends Behavior {
    rate: number;

    constructor(rate: number = 0.05) {
        super();
        this.rate = rate;
    }

    update(particle: Particle, grid: IGrid, index: number) {
        const x = index % grid.width;
        const y = Math.floor(index / grid.width);

        // 检查四周 (上下左右)
        const neighbors = [
            { idx: index - grid.width, valid: y > 0 },            // 上
            { idx: index + grid.width, valid: y < grid.height - 1 }, // 下
            { idx: index - 1, valid: x > 0 },                     // 左
            { idx: index + 1, valid: x < grid.width - 1 }         // 右
        ];

        for (const n of neighbors) {
            if (n.valid) {
                const neighbor = grid.pixels[n.idx];
                // 只与非空粒子交换热量
                // 如果想让空气也能冷却物体，可以去掉 !neighbor.empty，但通常空气冷却较慢，可以用 TemperatureNormalization 模拟
                if (neighbor && !neighbor.empty) {
                    this.transferHeat(particle, neighbor);
                }
            }
        }
    }

    private transferHeat(p1: Particle, p2: Particle) {
        const diff = p1.temperature - p2.temperature;
        
        // 温差很小时忽略
        if (Math.abs(diff) < 1) return;

        // 综合热导率
        // 使用乘积可以模拟：如果一方是绝热体，整体传热就受阻
        const conductivity = p1.props.thermalConductivity * p2.props.thermalConductivity;
        
        // 计算传递的热量
        let amount = diff * this.rate * conductivity;
        
        // 限制单次传递不超过温差的一半，防止温度震荡（A突然比B冷）
        const maxTransfer = diff * 0.5;
        
        if (Math.abs(amount) > Math.abs(maxTransfer)) {
            amount = maxTransfer;
        }

        p1.temperature -= amount;
        p2.temperature += amount;
        
        // 标记更新，防止这一帧重复计算（可选，目前粒子系统可能不需要严格的互斥）
    }
}
